import React, { useState, useEffect } from 'react';
import DesktopLanding from './DesktopLanding';
import MobileLanding from './MobileLanding';
import { LanguageProvider } from '../../../Core/Translations/LanguageContext';

const Landing: React.FC = () => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 970);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 970);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Clean up event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <LanguageProvider>
            {isDesktop ? <DesktopLanding /> : <MobileLanding />}
        </LanguageProvider>
    );
};

export default Landing;